export default "__VITE_ASSET__YCodMA2l__"